import { useState, useEffect, useContext } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import Select from "react-select";
import { Link, NavLink } from "react-router-dom";
import { handleDownloadOptions } from "../../Components/ExportData";

const ViewAllRequest = ({ customStyles }) => {

  const { apiURL, apiHeaderJson, apiHeaderFile, user_profile_id } =
    useContext(ConfigContext);
  const [consultantRequest, setConsultantRequest] = useState([]);
  const [rows, setRows] = useState([]);
  const [ItemRows, setItemRows] = useState([]);
  const [next, setNext] = useState(false);
  const [prev, setPrev] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loadingList, setLoadingList] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [reload, setReload] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [requestedInfo, setRequestedInfo] = useState({});
  const [selectOption, setSelectOption] = useState(null);
  const [status, setStatus] = useState(null);
  const [itemRemark, setItemRemark] = useState("");
  const [comment, setComment] = useState("");
  const [consultantInfo, setConsultantInfo] = useState([]);
  const [attachments, setAttachments] = useState([])
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedInspectionId, setSelectedInspectionId] = useState(null);
  const [projectRequestId, setProjectRequestId] = useState(null)
  const [contractorID, setContractorID] = useState(null)
  const [showModal, setShowModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState('');
  const [consultantData, setConsultantData] = useState([]);
  const [consultantId, setConsultantId] = useState(0);
  const [projectInspectionID, setProjectInspectionID] = useState(null)
  const [projectConsultantID, setProjectConsultantID] = useState(null)
  const [inspectionFormData, setInspectionFormData] = useState([]);
  const [inspectionFormID, setinspectionFormID] = useState(null);
  const [submittalDescription, setSubmittalDescription] = useState("");
  const [requiredInspection, setRequiredInspection] = useState(null);

  const options = [
    { value: "0", label: "Pending" },
    { value: "1", label: "Approved" },
    { value: "2", label: "Revise" },
    { value: "3", label: "Rejected" },
    { value: "4", label: "In-Clearance" },
  ];

  const submittalOptions = [
    "Sub-contractor pre-qualification",
    "Material & product data",
    "Method statement",
    "Design calculation",
    "Request for information",
    "Testing and commissioning",
    "Inspection request",
  ];

  const getProjectConsultant = async () => {
    try {
      const response = await axios.get(`${apiURL}api/project-consultants/project/${selectedProjectId}`);
      const { data, success } = response.data;
      console.log(data, "ConsultantData");

      if (success === true) {
        setConsultantData(
          data.map((row) => ({
            value: row.consultant_id,
            label: row.profile_name
          }))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSelect = (selectedOption) => {
    setinspectionFormID(selectedOption ? selectedOption.value : null);
  };

  const getInspectionForm = async () => {
    try {
      const headers = apiHeaderJson;
      const response = await axios.get(`${apiURL}api/inspections/GetInspections`, { headers });
      const { data } = response.data;

      setInspectionFormData(
        data
          .map(row => ({
            value: row.inspection_id,
            label: row.inspection_title
          }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const AcceptRejectRequest = (actionType) => {
    Swal.fire({
      title: `Submit Remark for ${actionType}`,
      input: "text",
      inputPlaceholder: "Enter your Remark",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "Remark cannot be empty";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Remark successfully submitted",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (actionType === "Accept") {
            setStatus("approved");
          } else if (actionType === "Cancel") {
            setStatus("rejected");
          }
        });
      }
    });
  };

  const handleApprove = () => {
    Swal.fire({
      icon: "success",
      title: "Request Approved Successfully",
      showConfirmButton: false,
      timer: 1500,
    });

    setStatus("approved");
  };

  const getAllRequests = async () => {
    try {
      const headers = apiHeaderJson;

      const params = {
        consultant_id: user_profile_id,
        request_status: selectOption || "1"
      };

      const response = await axios.get(`${apiURL}api/requests/GetAllRequestsForConsultant`, { params, headers })
      const { data, success } = response.data;
      console.log(data, "Consultant request");

      if (success === true) {
        setConsultantRequest(data)
        setNext(response.data.next);
        setPrev(response.data.prev);
        setPage(response.data.page);
        setTotalRecords(response.data.total_records);
        setTotalPages(response.data.total_pages);
        setProjectInspectionID(response.data.project_inspection_id || null)
        setProjectConsultantID(data?.project_id)
      }
      setLoadingList(false)
      setReload(false)
    } catch (error) {
      console.log(error);
    }
  };

  const GetInfo = (row) => {
    const headers = apiHeaderJson;
    setSelectedProjectId(row?.project_id || null);
    setSelectedInspectionId(row?.inspection_id || null);
    setProjectRequestId(row?.project_request_id || null)
    setContractorID(row?.contractor_id || null)
    setSubmittalDescription(row?.submittal_description || "")
    setRequiredInspection(row?.required_inspection ?? 0);

    axios
      .get(`${apiURL}api/requests/GetProjectRequestInfo?project_request_id=${row?.project_request_id}`, {
        headers,
      })
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          setRequestedInfo(data.info)
          setConsultantInfo(data.consultants)
          setAttachments(data.attachments)
        }
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "itemRemark") {
      setItemRemark(value);

    }
    else if (name === "comment") {
      setComment(value)
    }
    else if (name === "keyword") {
      setKeyword(value);
    }
  };

  const handleFilter = () => {
    setPage(1);
    setReload(true);
  };

  const GetList = async () => {
    try {
      const headers = apiHeaderJson;
      const response = await axios.get(
        `${apiURL}api/consultants/Get-Request-Items`,
        {
          params: { consultant_id: user_profile_id, page, limit },
          headers,
        }
      );
      const data = response.data;

      if (data.success) {
        setRows(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePrev = () => {
    if (prev) {
      setPage((prevPage) => prevPage - 1);
    }
  };

  const handleNext = () => {
    if (next) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const handleChange = (e) => {
    setPage(parseInt(e.target.value, 10));
  };

  const resetForm = () => {
    setItemRows("");
  };

  const handleClear = () => {
    setKeyword("");
    setReload(true);
  };

  const Labels = (status) => {
    if (status === 0) {
      return "Pending";
    } else if (status === 1) {
      return "Approved";
    } else if (status === 2) {
      return "Revise";
    }
    else if (status === 3) {
      return "Rejected";
    }
    else if (status === 4) {
      return "In-Clearence";
    }
  };

  const Classes = (status) => {
    if (status === 0) {
      return "badge bg-warning-subtle text-warning";
    } else if (status === 1) {
      return "badge bg-success-subtle text-success";
    } else if (status === 2) {
      return "badge bg-info-subtle text-info";
    } else if (status === 3) {
      return "badge bg-danger-subtle text-danger";
    } else if (status === 4) {
      return "badge bg-secondary-subtle text-secondary";
    }
  };

  const handleSelectStatus = (selectedOption) => {
    setSelectOption(selectedOption ? selectedOption.value : "");
    setReload(true); // Trigger reload when status changes
  };

  const ClearModal = () => {
    setComment('')
    setRequestedInfo({})
  }

  const typeText = (type) => {
    if (type === 1) {
      return 'Approve'
    }
    if (type === 2) {
      return "Reject"
    }
    if (type === 3) {
      return "Revise and Resubmit"
    }
  }

  const handleActionSubmit = async () => {
    const statusMap = {
      "Direct Approve": '1',
      "Reject": '3'
    };

    if (!selectedAction) {
      Swal.fire({
        icon: 'warning',
        title: 'Please select an action',
        timer: 1500,
        showConfirmButton: false
      });
      return;
    }

    const headers = apiHeaderJson;

    try {
      let response;

      if (selectedAction === "Clearance Required") {
        if (!consultantId) {
          Swal.fire({
            icon: 'warning',
            title: 'Please select a consultant for Clearance Required',
            timer: 1500,
            showConfirmButton: false
          });
          return;
        }

        const formData = new FormData();
        formData.append("project_request_id", projectRequestId);
        formData.append("project_id", selectedProjectId);
        formData.append("consultant_id", consultantId);
        formData.append("assigned_by", user_profile_id);
        formData.append("clearance_remark", comment);

        response = await axios.post(
          `${apiURL}api/requests/AssignForClearance`,
          formData,
          { headers }
        );

      } else if (selectedAction === "Revise") {
        if (!comment?.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Please enter a remark for revision',
            timer: 1500,
            showConfirmButton: false
          });
          return;
        }
        const formData = new FormData();
        formData.append("project_request_id", projectRequestId);
        formData.append("remark", comment);

        response = await axios.post(
          `${apiURL}api/requests/AskForRevision`,
          formData,
          { headers }
        );

      } else {
        const body = {
          project_request_id: projectRequestId,
          consultant_id: user_profile_id,
          consultant_status: statusMap[selectedAction],
          consultant_remark: comment
        };

        response = await axios.patch(
          `${apiURL}api/project-items/status`,
          body,
          { headers }
        );
      }

      const { success, message } = response.data;

      await Swal.fire({
        icon: success ? 'success' : "error",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });

      if (success) {
        setShowModal(false);
        clearActionModal();
        getAllRequests();
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error taking action',
        showConfirmButton: false,
        timer: 1500
      });
    }
  };

  const clearActionModal = () => {
    setSelectedAction('');
    setComment('');
    setConsultantId(0);
  }

  const handleModalCloseOrCancel = () => {
    clearActionModal()
    setShowModal(false);
  }

  const handleConsultantChange = (selectedOption) => {
    setConsultantId(selectedOption ? selectedOption.value : null);
  }

  const handleDownload = (downloadType) => {
    const endpoint = `api/requests/GetAllRequestsForConsultant`;
    const params = {
      consultant_id: user_profile_id,
      request_status: selectOption || "1"
    };

    const columns = [
      { header: "Project Name", width: 35 },
      { header: "Item Name", width: 26 },
      { header: "Quantity", width: 20 },
      { header: " Price(QAR)", width: 20 },
      { header: " Status", width: 25 },
    ];

    const mapRow = (data) => ({
      "Project Name": data?.project_title ?? "-",
      "Item Name": data?.item_name ?? "-",
      "Quantity": data?.pi_item_qty ?? "-",
      " Price(QAR)": data?.pi_item_price ?? "-",
      " Status": data?.consultant_given_status ? Labels(data.consultant_given_status) : Labels(data.request_status) ?? "-",
    });

    handleDownloadOptions(endpoint, params, columns, mapRow, downloadType, apiURL, apiHeaderJson);
  };

  useEffect(() => {
    GetList();
    getAllRequests()
  }, [page]);

  useEffect(() => {
    reload && getAllRequests();
  }, [reload, selectOption]);

  useEffect(() => {
    selectedProjectId && getProjectConsultant();
  }, [selectedProjectId])

  useEffect(() => {
    getInspectionForm();
  }, [])

  return (
    <div className="main-content">
      <div className="page-content">
        {loadingList === false ? (
          <div className="container-fluid">
            <br />
            <PageTitle title={`Requested Items`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div
                    className="card-header align-items-center d-flex"
                    style={{
                      background: "#000000",
                    }}
                  >
                    <h4 className="card-title mb-0 flex-grow-1 text-white">Requested List</h4>
                    <div className="col-md-3 mx-3 mb-3">
                      <div className="row">
                        <div className="col-md-5"></div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="card-body mb-0"
                    style={{ border: "none" }}
                  >
                    <div className="row py-2">
                      {/* <div className="col-md-4 d-flex align-items-center">
                        <label className="mb-0 fw-semibold">Filter by Status:</label>
                        <Select
                          options={options}
                          value={
                            selectOption
                              ? options.find((option) => option.value === selectOption)
                              : options.find((option) => option.value === "1")
                          }
                          onChange={handleSelectStatus}
                          className="w-100"
                          styles={customStyles}
                          placeholder="Please Select Status"
                        />
                      </div> */}

                      <div className="col-md-12 text-end">
                        <div className="dropdown">
                          <button
                            type="button"
                            className="btn btn-light btn-label waves-effect waves-light "
                            id="dropdownMenuLink4"
                            data-bs-toggle="dropdown"
                            aria-expanded="true"
                          >
                            <i className="ri-download-2-line label-icon align-middle fs-16 me-2" />
                            Download Report
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink4">
                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('print')}><i className="ri-printer-line me-2 align-middle text-muted" />Print</a>
                            </li>
                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('pdf')}><i className="ri-file-pdf-line me-2 align-middle text-muted" />PDF</a>
                              <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('excel')}><i className="ri-file-excel-2-line me-2 align-middle text-muted" />Excel</a>
                              </li>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="card-body">
                      <div className="table-responsive table-card">
                        <table className={`table table-bordered table-stripped`}>
                          <thead className="table-light text-center">
                            <tr>
                              <th>
                                Project Name
                              </th>
                              <th>
                                Item Name
                              </th>
                              <th>
                                Quantity
                              </th>
                              <th>
                                Price(QAR)
                              </th>
                              <th>
                                Request Type
                              </th>
                              <th>
                                Status
                              </th>
                              <th width="7%">
                                Action
                              </th>
                            </tr>
                          </thead>
                          {consultantRequest.length !== 0 ? (
                            <tbody>
                              {
                                consultantRequest.map((row) => (
                                  <tr key={row.category_id} className="text-center">
                                    <td>
                                      <NavLink to={`/ProjectProfile/${row?.project_id}`}>{row?.project_title}</NavLink>
                                    </td>
                                    <td>
                                      {row?.item_name ?? "-"}
                                    </td>
                                    <td>
                                      {row?.pi_item_qty ?? "-"}
                                    </td>
                                    <td>
                                      {row?.pi_item_price ?? "-"}
                                    </td>
                                    <td>
                                      {
                                        row.required_inspection === 1 ?
                                          <span className="badge bg-danger-subtle text-danger">Required</span> :
                                          <span className="badge bg-info-subtle text-info">Not Required</span>
                                      }
                                    </td>

                                    <td>
                                      <span className={Classes(row.request_status)}>
                                        {Labels(row.request_status)}
                                      </span>
                                    </td>

                                    <td className="d-flex justify-content-center gap-2">
                                      {row.request_status === 0 &&
                                        <button
                                          type="button"
                                          className="btn btn-link text-success fs-18 p-0"
                                          data-bs-toggle="modal"
                                          data-bs-target="#myModal"
                                          onClick={() => GetInfo(row)}
                                        >
                                          <i className=" ri-edit-line" />

                                        </button>}

                                      <Link to={`/PreviewStatus/${row?.project_request_id}`}>
                                        <button
                                          type="button"
                                          className="btn btn-link text-info fs-18 p-0"

                                        >
                                          <i className=" ri-eye-line" />
                                        </button>
                                      </Link>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          ) : (
                            <tbody>
                              <tr>
                                <td colSpan="8">
                                  <NoRecords />
                                </td>
                              </tr>
                            </tbody>
                          )}
                          <tfoot className="table-light">
                            <tr>
                              <th colSpan={9}>
                                <div className="d-flex justify-content-between">
                                  <button
                                    disabled={
                                      prev === false && loadingList === false
                                        ? true
                                        : false
                                    }
                                    type="button"
                                    onClick={() => handlePrev()}
                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                  >
                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                    Previous
                                  </button>
                                  <div
                                    className="col-md-4"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {
                                      <small>
                                        Total Records: {totalRecords} | Total
                                        Pages: {totalPages} | Current Page: {page}
                                      </small>
                                    }
                                  </div>
                                  <div className="col-md-2">
                                    <select
                                      className="form-select"
                                      onChange={(e) => handleChange(e)}
                                    >
                                      {Array.from(
                                        { length: totalPages },
                                        (_, i) => (
                                          <option
                                            key={i + 1}
                                            selected={page === i + 1}
                                            value={i + 1}
                                          >
                                            {i + 1}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </div>
                                  <button
                                    disabled={
                                      next === false && loadingList === false
                                        ? true
                                        : false
                                    }
                                    type="button"
                                    onClick={() => handleNext()}
                                    className={`btn btn-primary btn-label waves-effect right waves-light`}
                                  >
                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                                    Next
                                  </button>
                                </div>
                              </th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <ContentLoader />
        )}
      </div>
      <>
        <div
          id="myModal"
          className="modal fade"
          tabIndex={-1}
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          style={{ display: "none" }}
        >
          <form>
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                {/* Modal Header */}
                <div
                  className="modal-header d-flex justify-content-between align-items-center"
                  style={{ background: "#000000", padding: "15px" }}
                >
                  <div className="w-100">
                    <div className="row">
                      <div className="col-md-4">
                        <h5 className="mb-0 text-white">Title: {requestedInfo?.project_title ?? '-'}</h5>
                      </div>
                      <div className="col-md-4">
                        <h5 className="mb-0 text-white">Ref.#: {requestedInfo?.project_request_id ?? '0'}</h5>
                      </div>
                      <div className="col-md-4">
                        <h5 className="mb-0 text-white">Rev # : {requestedInfo?.request_revision_count ?? '0'}</h5>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => ClearModal()}
                    id="close-create-modal"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{ filter: "invert(1)" }}
                  ></button>
                </div>

                {/* Modal Body */}
                <div className="modal-body">

                  {/* Section: Item Details */}
                  <div className="mb-3 p-3 border rounded bg-white ">
                    <h6 className="text-primary mb-2">Item Details</h6>
                    <div className="row">
                      <div className="col-md-3">
                        <strong>Item Name:</strong> {requestedInfo?.item_name}
                      </div>
                      <div className="col-md-9">
                        <strong>Type of Submittal:</strong> {requestedInfo?.submittal_description}
                      </div>
                      <div className="col-md-12 mt-3">
                        <strong>Brief Description:</strong> {requestedInfo?.request_brief_description}
                      </div>
                    </div>
                  </div>

                  {/* Section: Form Selection */}
                  {requiredInspection === 0 ? <></> :
                    <div className="mb-3 p-3 border rounded bg-white">
                      <h6 className="text-primary mb-2">Select Inspection Form</h6>
                      <Select
                        onChange={handleFormSelect}
                        options={inspectionFormData}
                        placeholder="Select Form"
                        value={inspectionFormID ? inspectionFormData.find(opt => opt.value === inspectionFormID) : null}
                      />
                    </div>}

                  {/* Section: Uploaded Files */}
                  <div className="mb-3 p-3 border rounded bg-light">
                    <h6 className="text-primary mb-2">Uploaded Files</h6>
                    {attachments.length > 0 ? (
                      <div className="d-flex flex-wrap gap-3">
                        {attachments.map((file, index) => {
                          const fileUrl = file.attachment_path.replace(/\\/g, '');
                          const lowerUrl = fileUrl.toLowerCase();
                          const isPdf = lowerUrl.endsWith('.pdf');
                          const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(lowerUrl);

                          return (
                            <a
                              key={index}
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-decoration-none"
                              style={{ width: '100px' }}
                            >
                              <div className="p-2 bg-white rounded  d-flex flex-column align-items-center border">
                                <i
                                  className={`ri-${isPdf
                                    ? 'file-pdf-fill text-danger'
                                    : isImage
                                      ? 'image-fill text-primary'
                                      : 'file-fill text-secondary'
                                    } fs-1 mb-1`}
                                ></i>
                                <small className="text-truncate text-center text-muted" style={{ maxWidth: '80px' }}>
                                  {isPdf ? 'PDF Document' : isImage ? 'Image File' : 'Other File'}
                                </small>
                              </div>
                            </a>
                          );
                        })}
                      </div>
                    ) : (
                      <p className="text-muted mb-0">No File Uploaded</p>
                    )}
                  </div>

                  {/* Section: Contractor Details */}
                  <div className="mb-3 p-3 border rounded bg-white ">
                    <h6 className="text-primary mb-2">Contractor Details</h6>
                    <div className="row">
                      <div className="col-md-4">

                        <p><strong>Name:</strong> {requestedInfo?.profile_name}</p>

                      </div>
                      <div className="col-md-4">
                        <p><strong>Email:</strong> {requestedInfo?.profile_email}</p>

                      </div>
                      <div className="col-md-4">
                        <p><strong>Contact Number:</strong> {requestedInfo?.profile_contact_number}</p>
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="d-flex justify-content-end align-items-end mt-3">
                    {requiredInspection === 1 && (
                      <>
                        {projectInspectionID ? (
                          <button
                            type="button"
                            disabled
                            className="btn btn-success waves-effect waves-light me-2"
                          >
                            Complete Inspection
                          </button>
                        ) : (
                          <NavLink
                            to={
                              inspectionFormID
                                ? `/FillForm/${inspectionFormID}/${selectedProjectId}/${projectRequestId}/${contractorID}`
                                : "#"
                            }
                            onClick={(e) => {
                              if (!inspectionFormID) e.preventDefault();
                              document.getElementById("close-create-modal")?.click();
                            }}
                            className={`btn btn-success waves-effect waves-light me-2 ${!inspectionFormID ? "disabled" : ""
                              }`}
                            aria-disabled={!inspectionFormID}
                          >
                            Complete Inspection
                          </NavLink>
                        )}

                        <button
                          disabled={projectInspectionID === null}
                          type="button"
                          className="btn btn-info waves-effect waves-light"
                          onClick={() => {
                            setShowModal(true);
                            document.getElementById("close-create-modal")?.click();
                          }}
                        >
                          Take Action
                        </button>
                      </>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </form>
        </div>

        {/* /.modal */}
      </>
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Take Action</h5>
                <button type="button" className="btn-close" onClick={handleModalCloseOrCancel}></button>
              </div>
              <div className="modal-body">
                <div className="d-flex flex-wrap gap-2 justify-content-between mb-3">
                  {['Direct Approve', 'Revise', 'Reject', 'Clearance Required'].map(action => (
                    <button
                      key={action}
                      className={`btn ${selectedAction === action ? 'btn-primary' : 'btn-outline-primary'} flex-fill`}
                      onClick={() => setSelectedAction(action)}
                      style={{ minWidth: '140px' }}
                    >
                      {action}
                    </button>
                  ))}
                </div>

                {selectedAction === 'Clearance Required' && (
                  <div className="mb-3">
                    <Select
                      options={consultantData}
                      onChange={handleConsultantChange}
                      placeholder="Please select consultant"
                      value={consultantId ? consultantData.find(opt => opt.value === consultantId) : null}
                    />
                  </div>
                )}

                <textarea
                  className="form-control"
                  placeholder="Comment / Remark"
                  rows="4"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={!selectedAction && !comment}
                  onClick={() => {
                    setSelectedAction('');
                    setComment('');
                    setConsultantId(0);
                  }}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => handleModalCloseOrCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleActionSubmit}
                >
                  Submit Action
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ViewAllRequest;